// extracted by mini-css-extract-plugin
export default {"container":"VoltarLink_container__1xy4B","link":"VoltarLink_link__XwuQN","icon":"VoltarLink_icon__ijFbJ","text":"VoltarLink_text__n+htB"};